






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { googleBmApi } from '@/features/apps/googlebm/services/googlebmApi';
import Toast from '@/shared/services/toast';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { AgentTableRow } from '../models/agentTableRow';

@Component({})
export default class GoogleBmLaunchModal extends Vue {
	@Getter public currentWorkspace: WorkspaceViewModel;

	@Prop() public item!: AgentTableRow;

	public loading: boolean = false;

	public async launchItem() {
		if (this.loading || !this.item) {
			return;
		}
		this.loading = true;
		try {
			let result;
			if (this.item.rowType === 'agent') {
				result = await googleBmApi.requestAgentLaunch(this.currentWorkspace.id, this.item.customAgentId);
			} else {
				result = await googleBmApi.requestLocationLaunch(this.currentWorkspace.id, this.item.locationId);
			}

			this.item.launchStatus = result.launchState;
			Toast.showSuccess('Launch requested');
			this.$emit('launch', result.launchState);
		} catch (e) {
			Toast.showError(`Launch request failed: ${e.message}`);
		}
		this.loading = false;
	}
}
